export const CLEAR_FIELDS_TOOLTIP =
  'Apagamos o gatilho e o desconto informados manualmente. Se o ERP enviar valores para este produto e loja, passamos a usá-los na próxima integração de dados.';
